import { render } from "./TradePasswdBox.vue?vue&type=template&id=229fad1e"
import script from "./TradePasswdBox.vue?vue&type=script&lang=js"
export * from "./TradePasswdBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__